import { Component, OnInit } from '@angular/core';
import {UserService} from "../shared/user.service";
import {SyncService} from "./ax-mpoint-sync/sync.service";

@Component({
    selector: 'app-sync',
    templateUrl: './sync.component.html',
    styleUrls: ['./sync.component.scss'],
    standalone: false
})
export class SyncComponent implements OnInit {
  isAdmin = false;

  constructor(
    private service: SyncService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.isAdmin = this.userService.currentUser.isAdmin();
  }

  syncAxing() {
    this.service.syncAxing().subscribe((resp: any) => {

      if (resp.error) {
        return this.service.notiService.open(resp.error, 'OK', {duration: 5000});
      }
      this.service.notiService.open("Sikeres szinkronizálás. Több info a Logokban.", 'OK', {duration: 10000});
    });
  }
}
